import {
  WebhookEventDataType,
  EventStatusValue,
  EventStatusDisplayValue,
  GetWebhookEventsApiResponse,
  GetWebhookEventsResponse,
  WebhookEventResponse,
} from '../../../pages/MerchantWebhooks/types/types';

export const normalizeWebhookEvent = (event: WebhookEventResponse): WebhookEventDataType => ({
  eventId: event.eventId,
  eventStatus: event.eventStatus as EventStatusValue,
  displayStatus: event.displayStatus as EventStatusDisplayValue,
  endpointUrl: event.endpointUrl,
  customRequestHeaders: event.customRequestHeaders,
  maskedSecret: event.maskedSecret,
  failureNotificationEmails: event.failureNotificationEmails,
  eventType: event.eventType,
  merchantId: event.merchantId,
  notificationAttemptCount: event.notificationAttemptCount,
  notificationAttempts: (event.notificationAttempts || []).map((attempt) => ({
    notificationAttemptStatus: attempt.notificationAttemptStatus,
    responseCode: attempt.responseCode,
    failureMessage: attempt.failureMessage || '',
    created: attempt.created,
  })),
  subscriptionId: event.subscriptionId,
  created: event.created,
  lastNotificationAttemptAt:
    event.lastNotificationAttemptAt ?? event.notificationAttempts?.[0]?.created ?? null,
});

export const normalizeWebhookEvents = (events: WebhookEventResponse[]): WebhookEventDataType[] =>
  events.map(normalizeWebhookEvent);

export const normalizeWebhookEventsResponse = (
  response: GetWebhookEventsApiResponse,
): GetWebhookEventsResponse => ({
  data: normalizeWebhookEvents(response.data || []),
  pageData: {
    pageNumber: response.description?.pageNumber ?? 0,
    pageSize: response.description?.pageSize ?? 10,
    totalPages: response.description?.totalPages ?? null,
    totalRecords: response.description?.totalRecords ?? null,
    unseenRecords: response.description?.unseenRecords ?? null,
  },
});
